<template>
  <div id="contenedor-main-listado-auditorias-informes-respuestas">
    <template v-if="!$vuetify.breakpoint.xs">
      <desktop
        :items="listadoRespuestas"
        :informe="informe"
        >
      </desktop>
    </template>
    <template v-else>
      <desktop
        :items="listadoRespuestas"
        :informe="informe"
        >
      </desktop>
      <!-- <mobile :listadoRespuestas="listadoRespuestas"></mobile> -->
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoAuditoriasInformesRespuestas',
  props: {
    listadoRespuestas: {
      type: Array,
      required: true,
    },
    informe: {
      type: Object,
      required: true,
    },
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>
